module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 0
// module chunks = 0 3